var _a;
import { CardAdvancement, CardElement, CardFaction, CardGrade, CardRarity, } from '@cta-portal/webapp-common/lib/api/schema';
import cardsData from '../data/products/cards.json';
import { appEnv } from '../env';
export var metadataFactions = (_a = {},
    _a[CardFaction.ARKHANTE] = 'ARKHANTE',
    _a[CardFaction.MANTRIS] = 'MANTRIS',
    _a[CardFaction.RIFT] = 'RIFT',
    _a);
export var metadataSeasons = ['Arkhante', 'Mantris', 'Rift'];
export var sortedAdvancements = [CardAdvancement.COMBO, CardAdvancement.ALTERNATIVE, CardAdvancement.STANDARD];
export var sortedElements = [
    CardElement.LIFE,
    CardElement.EARTH,
    CardElement.DARK,
    CardElement.WATER,
    CardElement.FIRE,
    CardElement.LIGHT,
    CardElement.AIR,
];
export var sortedRarities = [
    CardRarity.UNIQUE,
    CardRarity.EXCLUSIVE,
    CardRarity.MYTHIC,
    CardRarity.ULTRA_RARE,
    CardRarity.SPECIAL_RARE,
    CardRarity.RARE,
    CardRarity.UNCOMMON,
    CardRarity.COMMON,
];
export var sortedGrades = [CardGrade.S, CardGrade.A, CardGrade.B, CardGrade.C];
export function generateCardImgUrl(ian, advancement, elements, foil, rank, grade, animationLevel) {
    var foilStr = foil ? '1' : '0';
    var traitStr = elements.sort().join('_').toLowerCase();
    var rankStr = advancement === CardAdvancement.STANDARD ? rank.toString() : '5';
    var gradeStr = advancement !== CardAdvancement.STANDARD && grade ? grade.toString().toLowerCase() : '0';
    return "".concat(appEnv.marketplaceImagesUrl.card).concat(ian, "-").concat(foilStr, "-").concat(traitStr, "-").concat(rankStr, "-").concat(gradeStr, "-").concat(animationLevel, ".png");
}
export function generateSouvenirCardImgUrl(id, foil) {
    var foilStr = foil ? '1' : '0';
    var gradeStr = '1';
    return "".concat(appEnv.marketplaceImagesUrl.souvenirCard).concat(gradeStr, "-").concat(id, "-").concat(foilStr, ".png");
}
export function getMinGrade(grades) {
    if (grades.length === 0)
        return CardGrade.C;
    return grades.sort(function (gradeA, gradeB) {
        var indexA = sortedGrades.indexOf(gradeA);
        var indexB = sortedGrades.indexOf(gradeB);
        return indexA - indexB;
    })[0];
}
export function getMinRank(ranks) {
    if (ranks.length === 0)
        return 1;
    return ranks.sort()[0];
}
export function getMinAnimationLevel(animationLevels) {
    if (animationLevels.length === 0)
        return 1;
    return animationLevels.sort()[0];
}
export function getAvailableRanksFromRarity(_rarity, _rarities) {
    // if (rarity) {
    //   switch (rarity) {
    //     case CardRarity.MYTHIC: {
    //       return [1, 3, 5]
    //     }
    //     case CardRarity.ULTRA_RARE: {
    //       return [1, 2, 3, 5]
    //     }
    //     default: {
    //       return [1, 2, 3, 4, 5]
    //     }
    //   }
    // } else if (rarities) {
    //   if (rarities.length === 1 && rarities.includes(CardRarity.MYTHIC)) {
    //     return [1, 3, 5]
    //   }
    //   if (rarities.length === 1 && rarities.includes(CardRarity.ULTRA_RARE)) {
    //     return [1, 2, 3, 5]
    //   }
    //   if (rarities.length === 2 && rarities.includes(CardRarity.MYTHIC) && rarities.includes(CardRarity.ULTRA_RARE)) {
    //     return [1, 2, 3, 5]
    //   }
    // }
    return [1, 2, 3, 4, 5];
}
export function generatePathFromEnum(enumValue) {
    return enumValue.toLowerCase().replace(/_/g, '-');
}
export function generateCardImgName(ian, foil, trait, rank, grade, animationLevel) {
    return "".concat(ian, "-").concat(foil, "-").concat(trait, "-").concat(rank, "-").concat(grade.toLowerCase(), "-").concat(animationLevel, ".png");
}
export function getHistoryItemImageUrl(ian, foil) {
    var localCard = cardsData.find(function (card) { return card.ian === ian; });
    var imgName = generateCardImgName(ian, foil ? '1' : '0', (localCard === null || localCard === void 0 ? void 0 : localCard.elements[0].toLowerCase()) || '', '1', '0', '1');
    return "".concat(appEnv.marketplaceImagesUrl.card).concat(imgName);
}
